// import React, {useEffect, useState} from "react";
import React from "react";

function Settings(props) {
    // const [stateName, setStateName] = useState('');
    // useEffect(() => {
    //     setStateName(props.stateName)
    // }, [props.stateName]);

    return (
        <div className="header-wether" id="header-weather">
            <span>
                {props.icon ? <img src={`https://openweathermap.org/img/wn/${props.icon}.png`} alt='Weather Map'/> :
                    <img src={`https://openweathermap.org/img/wn/04n.png`} alt='Weather Map'/>}
            </span>

            <a href={`https://earthview360.org/extension/public/weather?city=${encodeURIComponent(props.city)}&state=${encodeURIComponent(props.stateName)}`}
               target={'_blank'} rel="noreferrer">
                {props.isFahrenheit ?
                    <span id="celsius" style={{marginRight: "4px"}}>{!isNaN(props.temp) ? props.temp : 0}°F</span>
                    :
                    <span style={{marginRight: "4px"}} id="faranhite">
                        {isNaN(props.temp) ? 0 : parseInt((props.temp - 32 * (9 / 5)))}°C
                    </span>
                }
                {props.city}
            </a>
        </div>
    )
}

export default Settings